<template>
    <textarea
        ref="input"
        class="CFormTextarea input"
        v-bind="$attrs"
        :disabled="disabled"
        :maxlength="maxLength"
        :placeholder="placeholder"
        :value="modelValue"
        v-on="listeners"
        @input="handleInput"
    />

    <!-- <div v-if="maxLength" class="mt-1 text-sm" :class="{ 'text-red-500': isLimitReached }">
        {{ modelValue.length }}/{{ maxLength }}
    </div> -->
</template>

<script setup lang="ts">
import { useTransformInputListeners } from '@/components/composables/useTransformInputListeners'
import { ref, onMounted, computed } from 'vue'

const props = defineProps({
    modelValue: {
        type: String,
        default: ''
    },
    placeholder: {
        type: String,
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    },
    maxLength: {
        type: Number,
        default: null
    }
})

const emit = defineEmits(['update:modelValue', 'input', 'change'])

const input = ref<HTMLTextAreaElement | null>(null)
const { listeners } = useTransformInputListeners(emit)

function handleInput(event: Event) {
    const target = event.target as HTMLTextAreaElement
    emit('update:modelValue', target.value)
}

const isLimitReached = computed(() => {
    return props.maxLength && props.modelValue.length >= props.maxLength
})

onMounted(() => {
    adjustHeight()
})

function adjustHeight() {
    if (input.value) {
        input.value.style.height = 'auto'
        input.value.style.height = `${input.value.scrollHeight}px`
    }
}
</script>
